import { paramCleaner } from '@/helpers/formatters';
import { postRequest } from '@/api/request';
import { isEmpty } from 'lodash-es';

export const downloadApprovalsDashboardCsv = async ({
  params = {}, selectedFilters, searchTerm, owned,
}) => {
  const {
    sort, page, q, owned: ownedParam, ...paramFilters
  } = params;

  const cleanedParams = paramCleaner(paramFilters);

  const searchParams = new URLSearchParams();

  if (typeof sort !== 'undefined') searchParams.append('sort', sort);

  return postRequest({
    url: `/jobprofile/approval-flow/download-csv?${searchParams}`,
    body: {
      filters: !isEmpty(selectedFilters) ? selectedFilters : cleanedParams,
      textFilter: searchTerm,
      owned: owned !== undefined ? owned : ownedParam,
    },
    isCsv: true,
    timeout: 60000,
  });
};

export const getApprovalsDashboardTotals = async ({
  selectedFilters, searchTerm, params = {}, owned,
} = {}) => {
  const {
    sort, page, q, owned: ownedParam, ...paramFilters
  } = params;

  const cleanedParams = paramCleaner(paramFilters);

  return postRequest({
    url: '/jobprofile/approval-flow/totals',
    body: {
      filters: !isEmpty(selectedFilters) ? selectedFilters : cleanedParams,
      textFilter: searchTerm,
      owned: owned !== undefined ? owned : ownedParam,
    },
  });
};

export const getApprovalsDashboardDocuments = async ({
  params = {}, selectedFilters, searchTerm, owned,
}) => {
  const {
    sort, page, q, owned: ownedParam, ...paramFilters
  } = params;

  const cleanedParams = paramCleaner(paramFilters);

  const searchParams = new URLSearchParams();
  if (typeof sort !== 'undefined') searchParams.append('sort', sort);
  if (typeof page !== 'undefined') searchParams.append('page', page);

  const {
    items = [],
    filters = [],
    sorting = {},
    pagination = {},
    textFilter = {},
  } = await postRequest({
    url: `/jobprofile/approval-flow/documents?${searchParams}`,
    body: {
      filters: !isEmpty(selectedFilters) ? selectedFilters : cleanedParams,
      textFilter: searchTerm,
      owned: owned !== undefined ? owned : ownedParam,
    },
  });

  return {
    items,
    filters,
    sorting,
    pagination,
    textFilter,
  };
};
